<header [title]="title" icon="company" theme="neutral" condensed="true">
  <div class="entity-header" novo-title></div>
</header>
<div>
  <router-outlet></router-outlet>  
</div>